<template>
	<sa-page-layout :btnAnnullaVisible="false" :btnRouterBackVisible="true" :linkback="linkback"
		:pathResource="pathResource" :data="jsonData" :showModalLoading="showModalLoading">
		<template slot="table-body">
			<magazzino-articoli-edit-component @updateJsonData="onUpdateJsonData" @beforeLoadData="onBeforeLoadData"
				@afterLoadData="onAfterLoadData" ref="cmpMagazzinoArticoliEdit" />
			<!-- <magazzino-articoli-view-component /> -->
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import MagazzinoArticoliEditComponent from "../components/MagazzinoArticoliEditComponent.vue";
// import MagazzinoArticoliViewComponent from "../components/MagazzinoArticoliViewComponent.vue";
export default {
	name: "MagazzinoArticoliViewPage",
	components: { SaPageLayout, MagazzinoArticoliEditComponent },
	data() {
		return {
			showModalLoading: false,
			linkback: "/magazzino/articoli",
			pathResource: "/magazzinoarticoli",
			jsonData: null,
		};
	},
	methods: {
		onUpdateJsonData(jsonData) {
			this.jsonData = jsonData;
		},
		onBeforeLoadData() {
			let me = this;
			me.showModalLoading = true;
		},
		onAfterLoadData() {
			let me = this;
			me.showModalLoading = false;
		},
	},
};
</script>

<style></style>
